import { BaseComponent } from '../base-component.js';

export class AgFormGroup extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-form-group"><slot></slot></div>`;
  }
}

customElements.define('ag-form-group', AgFormGroup);
